/**
 * DOMAIN LAYER — helpers puros sobre el `Admin` que viene del back.
 *
 * El tipo `Admin` y `Permission` se importan desde
 * `@/store/apis/adminApi.types` (que refleja el contrato del swagger).
 * Este módulo solo agrega funciones puras de negocio.
 */
import type { Admin, Permission } from "@/store/apis/adminApi.types";

export const PERMISSION_LABELS: Record<Permission, string> = {
  "dashboard.read": "Ver dashboard",
  "audit.read": "Ver auditoría",
  "advice.read": "Ver consejos",
  "advice.write": "Editar consejos",
  "popups.read": "Ver pop-ups",
  "popups.write": "Editar pop-ups",
  "circle.read": "Ver Círculo",
  "content.upload": "Subir contenido",
  "admins.manage": "Gestionar admins",
};

export function hasPermission(admin: Admin | null, permission: Permission): boolean {
  if (!admin) return false;
  return admin.permissions.includes(permission);
}

export function hasAnyPermission(admin: Admin | null, permissions: readonly Permission[]): boolean {
  if (!admin) return false;
  return permissions.some((p) => admin.permissions.includes(p));
}
